/* eslint-disable no-nested-ternary */
// eslint-disable-next-line max-classes-per-file
import React, { Component } from 'react';
import Select from 'react-select';
import {
  Button, DashboardView, DashboardBody, Error, Grid, Spinner, Toolbar,
} from './RPDashboard.styles';
import AppContext from '../../AppContext';
import NavLinkButton from 'Library/GrpGrid/NavLinkButton/NavLinkButton';
import UrlPoller from 'Library/UrlPoller/UrlPoller';
import 'Styles/SCSS/ag-theme-material.scss';
import Auth0SessionInfo from 'Services/Auth0SessionInfo';
import APIM from 'Services/APIM';
import CDATA from 'Services/CDATA';
import { renderWithPermissions } from 'Components/Auth0/permissionFunctions';
import { permissionTypes } from 'Constants/Auth0Constants';

const PreviewButton = () => 'Show Preview';

let PermissionPrefix = '';

const linkData = (data, path) => ({
  pathname: path,
  classcode_bk: data.classcode_bk,
  language: data.iso_languages,
  fundcode_bk: data.fundcode_bk,
  of_full_share_class_name: data.of_full_share_class_name,
  action_type: 'Edit',
  regulation_name: 'CEPT',
});

const PreviewButtonLink = (data) => (data ? linkData(data, '/regulatory-reporting/preview/ceptresults') : null);

class RPceptDashboard extends Component {
  constructor(props) {
    super(props);
    this.PermissionPrefix = props.location.pathname.toLowerCase().endsWith('cept') ? 'dashboard/' : '';
    this.state = {
      api_name: this.props.api_name,
      displayedRowCount: 0,
      error_or_warning: 'Error',
      failed: false,
      loading: true,
      page: window.location.pathname,
      redirect: false,
      regulation_name: 'CEPT',
      totalRowCount: 0,
      toolbarButtons: [
        renderWithPermissions(() => (
          <Button
            key={0}
            onClick={() => { this.create(); }}
            size="Medium"
            type="Secondary"
            text="Create CEPT in Bulk"
          />
        ), this.PermissionPrefix + permissionTypes.create, () => <></>),
        renderWithPermissions(() => (
          <Button
            key={2}
            onClick={() => { this.approve(); }}
            size="Medium"
            type="Primary"
            text="Run Calculations"
          />
        ), this.PermissionPrefix + permissionTypes.calculations, () => <></>),
        renderWithPermissions(() => (
          <Button
            key={3}
            onClick={() => { this.populateRuleReg(); }}
            size="Medium"
            type="Secondary"
            text="Rule Regulation Population"
          />
        ), this.PermissionPrefix + permissionTypes.generate, () => <></>),
        <Button
          key={4}
          onClick={() => { this.createExtract(); }}
          size="Medium"
          type="Primary"
          text="Extract"
        />,
        <Button
          onClick={() => { this.refresh(); }}
          icon={['fas', 'sync']}
          iconSide="Round"
          size="Small"
        />,
      ],
      rowData: [],
      monitorUrl: '',
      monitorType: '',
    };
  }

  componentDidMount() {
    this.getMetadata();
  }

  async getMetadata() {
    try {
      const columns = await CDATA.makeRequest(
        'POST',
        'PRIIPS_app_GET_COLUMNS',
        '',
        {
          API_NAME: this.state.api_name,
          MERGE_QUEUE_ID: -99,
        },
        'Error retrieving column names and metadata.',
      );
      const columnDefs = this.mapColumns(columns.value);

      if (this.state.api_name === 'PRIIPS_app_VALIDATION_DASHBOARD') {
        columnDefs.unshift({
          field: 'Edit',
          headerName: 'Create/Edit',
          cellRenderer: (props) => (
            renderWithPermissions(() => (
              <Button
                className="Secondary"
                size="Small"
                text={<div style={{ color: '#8700FF' }}>Create</div>}
                onClick={() => { this.createCEPT(props.data.classcode_bk); }}
              />
            ),
              this.PermissionPrefix + permissionTypes.create,
              () => <></>)
          ),
        });

        columnDefs.unshift({
          field: 'Preview',
          headerName: 'Risk & Performance Calculation',
          cellRenderer: (props) => (
            <NavLinkButton
              {...props}
              functionToGenerateContent={PreviewButton}
              functionToGenerateLink={PreviewButtonLink}
            />
          ),
          sortable: true,
          cellClass: 'ag-cell',
          valueGetter: (props) => PreviewButton(props.data),
          enablePivot: false,
          enableRowGroup: false,
          enableValue: false,
        });

        columnDefs.unshift({
          field: 'SelectRow',
          headerName: '',
          checkboxSelection: true,
          headerCheckboxSelection: true,
          headerCheckboxSelectionFilteredOnly: true,
          sortable: false,
          maxWidth: 45,
          resizable: false,
        });
      }

      setTimeout(() => this.setState({ columnDefs, rawColumns: columns.value }),10);
    } catch (err) {
      this.setState({
        loading: false,
        failed: true,
        failMessage: 'We\'re sorry, there was an issue loading the columns for this table. Please try again. If the issue persists, contact your administrator.',
      });
      console.log(err);
    }
  }

  async getData() {
    try {
      this.gridApi.updateGridOptions({ rowData:[]});
      let payload = {
        clientcode: this.context.state.selectedClient.code,
        reportingperiod: this.context.state.selectedReportingDate.code,
        ruleregulation: this.state.regulation_name,
      };
      if (this.state.api_name !== 'PRIIPS_app_VALIDATION_DASHBOARD') {
        payload.resulttodisplay = this.state.error_or_warning;
      }
      const data = await CDATA.makeRequest(
        'POST',
        this.state.api_name,
        '',
        payload,
        'Error retrieving data.',
      );
      const totalRowCount = data && data['@odata.count'] !== 0 ? data['@odata.count'] : data.value.filter((item) => item.return_value !== '0').length;
      const filteredData = data.value.filter((item) => item.return_value !== '0');
      this.setState({ rowData: filteredData });
      setTimeout(
        ()=>{
          this.gridApi.onFilterChanged();
        }
      ,10);
      this.setState({ loading: false, totalRowCount });
      if (this.state.selectedValue) { 
        const selectedValue = this.state.selectedValue; 
        this.setState(selectedValue); 
      }
    } catch (err) {
      this.setState({
        loading: false,
        failed: true,
        failMessage: 'We\'re sorry, there was an issue loading this data. Please try again. If the issue persists, contact your administrator.',
      });
    }
  }

  populateRuleReg = async () => {
    try {
      const ruleReportType = this.state.regulation_name;
      const data = {
        procedure: 'app.PopulateRuleRegulationDashboard',
        clientcode: this.context.state.selectedClient.code,
        parameters: {
          ClientCode: this.context.state.selectedClient.code,
          ReportingPeriod: this.context.state.selectedReportingDate.code,
          RuleRegulation: ruleReportType,
          FundCode: null,
          ClassCode: null
        },
      };

      APIM.makeRequest(
        'transaction',
        JSON.stringify(data),
        'Error in Rule Regulation Population for ' + ruleReportType + '.',
        Auth0SessionInfo.GetSessionInfo().accessToken,
      )
        .then((res) => {
          const toast = {
            type: 'success',
            body: (
              <>
                {'You successfully queued Rule Regulation Population for ' + ruleReportType + '.'}
              </>
            ),
          };
          this.context.handlers.setToast(toast);
          this.setState({ monitorUrl: res.statusQueryGetUri , monitorType: 'Rule Regulation Population for ' + ruleReportType});
          //this.refreshData();
        })
        .catch((error) => {
          console.log(error);
          this.context.handlers.closeModal();
          const toast = {
            type: 'error',
            body: (
              <>
                Error - something went wrong and we were not able to run Rule Regulation Population
              </>
            ),
          };
          this.context.handlers.setToast(toast);
        });

    } catch(err) {
      console.log(err);
    }
  };

  mapColumns = (rawColumns) => rawColumns.map((x) => ({
    field: x.dv_column,
    headerName: x.display_name,
    hide: x.is_hidden,
    editable: x.editable,
    comparator: x.sorttype !== undefined && x.sorttype.toLowerCase() === 'numeric' && ((value1, value2) => (value1 - value2)),
    // this is if you want to do a default sort for a specific column
    sort: x.dv_column.toLowerCase() === 'classcode_bk' ? {
      direction: 'desc',
      priority: 0,
    } : null,
  }));

  onGridReady = async (params) => {
    this.gridApi = params.api;
    this.gridColumnApi = params.columnApi;
    await this.getData();
  };

  onModelUpdated = (params) => {
    if(this.state.displayedRowCount !== params.api.getDisplayedRowCount())
      this.setState({ displayedRowCount: params.api.getDisplayedRowCount() });
  }

  approve = () => {
    const listOfRows = this.gridApi.getSelectedRows();
    if (listOfRows.length > 0) {
      const modalContent = (
        <div>
          <p>
            {`Are you sure you want to run the calculation for ${listOfRows.length} row(s)?`}
          </p>
          <Button onClick={() => this.approveRecords()} size="Medium" type="Primary" text="Ok" />
          <Button
            onClick={() => this.context.handlers.toggleModal()}
            size="Medium"
            type="Primary"
            text="Cancel"
          />
        </div>
      );
      this.context.handlers.setModal('Run R&P', modalContent, null, null, false);
      this.context.handlers.toggleModal();
    } else {
      const toast = {
        type: 'error',
        body: (<>No rows were selected to run the calculation.</>),
      };
      this.context.handlers.setToast(toast);
    }
  }

  approveRecords = () => {
    const listOfRows = this.gridApi.getSelectedRows();
    const delimClassCodes = listOfRows.map((row) => row.classcode_bk).join(',');
    const delimCategory = listOfRows.map((row) => row.category).filter((value, index, self) => self.indexOf(value) === index).join(',');
    const modalContent = <div><p>{`Running Risk and Performance Calculation for ${listOfRows.length} row(s)...`}</p></div>;
    this.context.handlers.setModal('Running Calculation ...', modalContent, null, null, true);
    // console.log(delimCategory[0])

    let data = {
      procedure: 'app.Risk_And_Performance_AssetManager_CEPT_Update',
      clientcode: this.context.state.selectedClient.code,
      parameters: {
        Client_Code: this.context.state.selectedClient.code,
        Class_Codes: delimClassCodes,
        CalcDate: this.context.state.selectedReportingDate.code,
        USER: this.context.state.userEmail,
        AzureID: this.context.state.userAzureID,
        Class_Name: '',
        Entity: `Calculation for the ${delimCategory} regulation`,
        UPDATE: true,
      },
    };

    APIM.makeRequest('transaction', JSON.stringify(data), 'Approve failed.', Auth0SessionInfo.GetSessionInfo().accessToken)
      .then((res) => { // res
        this.context.handlers.closeModal();
        const toast = {
          type: 'success',
          body: (
            <>
              {'You queued '}
              <span>{listOfRows.length}</span>
              {' row'}
              {listOfRows.length > 1 ? 's' : ''}
              {' for the '}
              {delimCategory}
              {' regulation Calculation. Please wait...'}
              .
            </>
          ),
        };
        this.context.handlers.setToast(toast);
        this.setState({
          monitorUrl: res.statusQueryGetUri,
          monitorType: data.parameters.Entity
        });
      })
      .catch(() => { // error
        this.context.handlers.closeModal();
        const toast = {
          type: 'error',
          body: (
            <>
              {'Error - something went wrong and we were not able to run the '}
              <span>{listOfRows.length}</span>
              {' row'}
              {listOfRows.length > 1 ? 's' : ''}
              {' you had selected.'}
            </>
          ),
        };
        this.context.handlers.setToast(toast);
      });
  }

  createExtract = async () => {
    if (this.state.totalRowCount === 0) {
      const toast = {
        type: 'error',
        body: (<>No data available to extract.</>),
      };
      this.context.handlers.setToast(toast);
      return;
    }
    const data = {
      procedure: 'CEPT_Prices_Extract',
      ClientCode: this.context.state.selectedClient.code,
      parameters: {
        Client_Code: this.context.state.selectedClient.code,
        Reference_Date: this.context.state.selectedReportingDate.code,
      },
    };

    APIM.makeRequest('generateExtract', JSON.stringify(data), 'Error CEPT Prices Extract', Auth0SessionInfo.GetSessionInfo().accessToken)
      .then((res) => {
        this.context.handlers.closeModal();
        const toast = {
          type: 'success',
          body: (
            <>
              {'You have successfully submitted data extract request.'}
              {'Please check for the results in a few minutes'}
            </>
          ),
        };
        this.context.handlers.setToast(toast);
        this.setState({ monitorUrl: res.statusQueryGetUri, monitorType: 'CEPT Prices Extract Generation' })
      })
      .catch(() => {
        this.context.handlers.closeModal();
        const toast = {
          type: 'error',
          body: (
            <>
              Error - something went wrong and we were not able to generate the extract you requested.
            </>
          ),
        };
        this.context.handlers.setToast(toast);
      });
  }

  handleSelect = (selectedValue) => {
    // console.log(event);
    this.setState({
      error_or_warning: selectedValue.label === 'All Warnings' ? 'Warning' : 'Error',
      api_name: selectedValue.value,
      selectedValue: selectedValue,
      loading: true,
    }, () => { this.refresh(); });
  }

  create = () => {
    const listOfRows = this.gridApi.getSelectedRows();
    if (listOfRows.length > 0) {
      const modalContent = (
        <div>
          <p>
            {`Are you sure you want to create the CEPT for ${listOfRows.length} row(s)?`}
          </p>
          <Button onClick={() => this.createCEPTBulk(true)} size="Medium" type="Primary" text="Update All Fields" />
          <Button onClick={() => this.createCEPTBulk(false)} size="Medium" type="Primary" text="Update Only Calculated" />
          <p style={{ paddingTop: 10 }}>
            <Button
              onClick={() => this.context.handlers.toggleModal()}
              size="Medium"
              type="Primary"
              text="Cancel"
            />
          </p>
        </div>
      );
      this.context.handlers.setModal('Create CEPT', modalContent, null, null, false);
      this.context.handlers.toggleModal();
    } else {
      const toast = {
        type: 'error',
        body: (<>No rows were selected to create the CEPT.</>),
      };
      this.context.handlers.setToast(toast);
    }
  }

  createCEPTBulk = (update) => {
    const listOfRows = this.gridApi.getSelectedRows();
    const delimClassCodes = listOfRows.map((row) => row.classcode_bk).join(',');
    // const delimCategory = listOfRows.map((row) => row.category);
    const modalContent = <div><p>{`Creating CEPT for ${listOfRows.length} row(s)...`}</p></div>;
    this.context.handlers.setModal('Creating CEPT ...', modalContent, null, null, true);
    // console.log(delimCategory[0])
    CDATA.makeRequest('POST',
      'PRIIPS_app_CREATE_CEPT_BULK',
      '',
      {
        ClientCode_bk: this.context.state.selectedClient.code,
        Reference_Date: this.context.state.selectedReportingDate.code,
        ClassCodeList: delimClassCodes,
        UserName: this.context.state.userEmail,
        UpdateAll: update,
      },
      'Create failed.')
      .then((res) => {
        this.context.handlers.closeModal();
        const toast = {
          type: 'success',
          body: (
            <>
              {'You successfully ran the calculation for '}
              <span>{listOfRows.length}</span>
              {' row'}
              {listOfRows.length > 1 ? 's' : ''}
              .
            </>
          ),
        };
        this.context.handlers.setToast(toast);
        this.refresh();
      })
      .catch((error) => {
        this.context.handlers.closeModal();
        const toast = {
          type: 'error',
          body: (
            <>
              {'Error - something went wrong and we were not able to create CEPT for the '}
              <span>{listOfRows.length}</span>
              {' row'}
              {listOfRows.length > 1 ? 's' : ''}
              {' you had selected.'}
            </>
          ),
        };
        this.context.handlers.setToast(toast);
      });
  }

  async createCEPT(classcode_bk) {
    const modalContent = (
      <div>
        <p>{`Creating CEPT for ${classcode_bk} ...`}</p>
      </div>
    );
    this.context.handlers.setModal('Creating ...', modalContent, null, null, true);
    this.context.handlers.toggleModal();
    try {
      await CDATA.makeRequest(
        'POST',
        'PRIIPS_app_CREATE_CEPT_BULK',
        '',
        {
          ClientCode_bk: this.context.state.selectedClient.code,
          Reference_Date: this.context.state.selectedReportingDate.code,
          ClassCodeList: classcode_bk,
          UserName: this.context.state.userEmail,
          UpdateAll: true,
        },
        'We\'re sorry, there was an error accepting the data and merging it into the application.',
        // console.log(classcode_bk)
      );
      this.context.handlers.closeModal();
      const toast = {
        type: 'success',
        body: (
          <>
            {'You successfully created the CEPT for '}
            <span>{classcode_bk}</span>
            .
          </>
        ),
      };
      this.context.handlers.setToast(toast);
      this.setState({ loading: false, redirect: true });
    } catch (err) {
      this.context.handlers.closeModal();
      const toast = {
        type: 'error',
        body: (
          <>
            {'Error - something went wrong and we were not able to create the CEPT for '}
            <span>{classcode_bk}</span>
            .
          </>
        ),
      };
      this.context.handlers.setToast(toast);
    }
  }

  async refresh() {
    await this.getMetadata();
    await this.getData();
  }

  onPollingDone() {
    this.setState({ monitorUrl: undefined })
  }

  render() {
    return (
      <DashboardView>
        <DashboardBody>
          {
            this.state.failed ? <Error text={this.state.failMessage} /> : (
              <>
                {
                  this.state.loading ? <Spinner text="Loading data..." /> : (
                    this.gridApi && (
                      <Toolbar
                        api={this.gridApi}
                        working={this.state.toolbarWorking}
                        exportName={this.state.api_name}
                        controls={this.state.api_name === 'PRIIPS_app_VALIDATION_DASHBOARD' ? this.state.toolbarButtons : null}
                        dropdown={(
                          <Select
                            isSearchable
                            options={[
                              { label: 'Share Class Dashboard', value: 'PRIIPS_app_VALIDATION_DASHBOARD' },
                              { label: 'Business Rule Dashboard', value: 'PRIIPS_app_VALIDATION_BY_RULE' },
                              { label: 'All Errors', value: 'PRIIPS_app_VALIDATION_RESULT_VIEW' },
                              { label: 'All Warnings', value: 'PRIIPS_app_VALIDATION_RESULT_VIEW' },
                            ]}
                            // components={{ Option: CustomOption }}
                            value={this.state.selectedValue}
                            ignoreAccents={false}
                            // filterOption={createFilter({ignoreAccents: false})}
                            onChange={this.handleSelect}
                            isOptionSelected={(option, selectedValue) => {return selectedValue.some((i) => i.label == option.label)}}
                          />
                        )}
                        count={{
                          total: this.state.totalRowCount,
                          showing: this.state.displayedRowCount,
                        }}
                      />
                    )
                  )
                }
                <Grid
                  columnDefs={this.state.columnDefs}
                  rawColumnData={this.state.rawColumns}
                  rowData={this.state.rowData}
                  onGridReady={this.onGridReady}
                  apiName={this.state.api_name}
                  onModelUpdated={this.onModelUpdated}
                  pivotable
                // autoGroupColumnDef = {this.state.autoGroupColumnDef}
                // treeData={this.props.treeData}
                />
              </>
            )
          }
        </DashboardBody>
        <div>
          {
            this.state.monitorUrl ? (
              <UrlPoller
                monitorUrl={this.state.monitorUrl}
                refreshIntervalSeconds={10}
                monitorType={this.state.monitorType}
                endStates={['Completed']}
                completeCallback={() => this.onPollingDone()}
              />
            ) : <></>
          }
        </div>
      </DashboardView>
    );
  }
}

RPceptDashboard.contextType = AppContext;

export default RPceptDashboard;
